import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import * as autoThunks from 'features/auto-thunks'
import WatchingProfileMetric from './watching-profile-metric-model'
import {
  CreateWatchingProfileMetricAsync,
  DeleteWatchingProfileMetricAsync,
  LoadWatchingProfileMetricsAsync,
} from './watchingProfileMetric-thunk'
const initialState: watchingProfileMetricSliceState = {
  watchingProfileMetric: [],
  selected_watchingProfileMetric: '',
  is_loading_watchingProfileMetric: false,
  is_creating_watchingProfileMetric: false,
  is_deleting_watchingProfileMetric: false,
}
export interface watchingProfileMetricSliceState {
  watchingProfileMetric: WatchingProfileMetric[]
  selected_watchingProfileMetric?: string
  is_loading_watchingProfileMetric: boolean
  is_creating_watchingProfileMetric: boolean
  is_deleting_watchingProfileMetric: boolean
}
export const watchingProfileMetricSlice = createSlice({
  name: 'watchingProfileMetric',
  initialState,
  reducers: {
    setSelectedwatchingProfileMetric: (state, action) => {
      state.selected_watchingProfileMetric = action.payload
    },
    clearStatewatchingProfileMetric: (state) => {
      state.watchingProfileMetric = []
      state.is_loading_watchingProfileMetric = false
      state.is_creating_watchingProfileMetric = false
      state.is_deleting_watchingProfileMetric = false
    },
    mergewatchingProfileMetric: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_watchingProfileMetric = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.watchingProfileMetric = merge(
            state.watchingProfileMetric,
            payload,
          ) as any
        }
      }
    },

    add_watchingProfileMetric: (state, action) => {
      if (action.payload) {
        state.watchingProfileMetric = [
          ...state.watchingProfileMetric,
          action.payload,
        ]
      }
    },
    set_watchingProfileMetric: (state, action) => {
      let { key, value, id } = action.payload
      state.watchingProfileMetric = state.watchingProfileMetric.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadWatchingProfileMetricsAsync.pending, (state) => {
      state.is_loading_watchingProfileMetric = true
    })
    builder.addCase(
      LoadWatchingProfileMetricsAsync.fulfilled,
      (state, action) => {
        state.is_loading_watchingProfileMetric = false
        if (action.payload) {
          state.watchingProfileMetric = action.payload
        }
      },
    )
    builder.addCase(LoadWatchingProfileMetricsAsync.rejected, (state) => {
      state.is_loading_watchingProfileMetric = false
    })
    builder.addCase(CreateWatchingProfileMetricAsync.pending, (state) => {
      state.is_creating_watchingProfileMetric = true
    })
    builder.addCase(CreateWatchingProfileMetricAsync.fulfilled, (state) => {
      state.is_creating_watchingProfileMetric = false
    })
    builder.addCase(CreateWatchingProfileMetricAsync.rejected, (state) => {
      state.is_creating_watchingProfileMetric = false
    })
    builder.addCase(DeleteWatchingProfileMetricAsync.pending, (state) => {
      state.is_deleting_watchingProfileMetric = true
    })
    builder.addCase(
      DeleteWatchingProfileMetricAsync.fulfilled,
      (state, action) => {
        state.is_deleting_watchingProfileMetric = false
        if (state.watchingProfileMetric) {
          state.watchingProfileMetric = state.watchingProfileMetric.filter(
            (x) => action.payload.id !== x.id,
          )
        }
      },
    )
    builder.addCase(DeleteWatchingProfileMetricAsync.rejected, (state) => {
      state.is_deleting_watchingProfileMetric = false
    })

    builder.addCase(autoThunks.on_watching_media_complex.pending, (state) => {
      state.is_loading_watchingProfileMetric = true
    })
    builder.addCase(
      autoThunks.on_watching_media_complex.fulfilled,
      (state, action) => {
        state.is_loading_watchingProfileMetric = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.on_watching_media_complex.rejected, (state) => {
      state.is_loading_watchingProfileMetric = false
    })

    builder.addCase(autoThunks.get_profile_history_metrics.pending, (state) => {
      state.is_loading_watchingProfileMetric = true
    })
    builder.addCase(
      autoThunks.get_profile_history_metrics.fulfilled,
      (state, action) => {
        state.is_loading_watchingProfileMetric = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.get_profile_history_metrics.rejected,
      (state) => {
        state.is_loading_watchingProfileMetric = false
      },
    )
  },
})

function handleResult(action: any, state: watchingProfileMetricSliceState) {
  if (action.payload) {
    let payload: any = action.payload
    if (payload?.data) {
      if (!Array.isArray(payload.data)) {
        state.selected_watchingProfileMetric = payload?.data?.id
        payload = [payload.data]
      } else {
        payload = payload.data
      }
      state.watchingProfileMetric = merge(
        state.watchingProfileMetric,
        payload,
      ) as any
    }
  }
}

export const {
  clearStatewatchingProfileMetric,
  setSelectedwatchingProfileMetric,
  set_watchingProfileMetric,
  mergewatchingProfileMetric,
  add_watchingProfileMetric,
} = watchingProfileMetricSlice.actions

export const get_watchingProfileMetric =
  (id?: string) =>
  (state: {
    watchingProfileMetric: {
      watchingProfileMetric: WatchingProfileMetric[]
    }
  }): WatchingProfileMetric | null => {
    let temp = state?.watchingProfileMetric?.watchingProfileMetric?.find(
      (v) => v.id === id,
    )
    if (temp) {
      return temp
    }
    return state?.watchingProfileMetric?.watchingProfileMetric[0] || null
  }
export const get_selected_watchingProfileMetric = (state: {
  watchingProfileMetric: watchingProfileMetricSliceState
}): WatchingProfileMetric | null => {
  let id = state?.watchingProfileMetric?.selected_watchingProfileMetric
  let temp = state?.watchingProfileMetric?.watchingProfileMetric?.find(
    (v) => v.id === id,
  )
  if (temp) {
    return temp
  }
  return null
}
export const get_all_watchingProfileMetric = (state: {
  watchingProfileMetric: {
    watchingProfileMetric: WatchingProfileMetric[]
  }
}): WatchingProfileMetric[] => {
  let temp = state?.watchingProfileMetric?.watchingProfileMetric
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_watchingProfileMetric_busy = (state: {
  watchingProfileMetric: watchingProfileMetricSliceState
}) => {
  return (
    state?.watchingProfileMetric.is_deleting_watchingProfileMetric ||
    state?.watchingProfileMetric.is_loading_watchingProfileMetric ||
    state?.watchingProfileMetric.is_creating_watchingProfileMetric
  )
}
export const is_deleting_watchingProfileMetric_busy = (state: {
  watchingProfileMetric: watchingProfileMetricSliceState
}) => {
  return state?.watchingProfileMetric.is_deleting_watchingProfileMetric
}
export const is_loading_watchingProfileMetric_busy = (state: {
  watchingProfileMetric: watchingProfileMetricSliceState
}) => {
  return state?.watchingProfileMetric.is_loading_watchingProfileMetric
}
export const is_creating_watchingProfileMetric_busy = (state: {
  watchingProfileMetric: watchingProfileMetricSliceState
}) => {
  return state?.watchingProfileMetric.is_creating_watchingProfileMetric
}

export default watchingProfileMetricSlice.reducer
